import util from '@/util';
const def_text_opts = {
    splitByGrapheme: true
}
const temp_canvas_id = 'fabricCanvas';
export default {
    getCanvas(bgColor, width, height) {
        let c = document.createElement('canvas');
        c.width = width;
        c.height = height;
        c.id = temp_canvas_id;
        c.style.cssText = `width: ${width}px;height: ${height}px;background-color: ${bgColor}`;
        document.body.appendChild(c);
        let fCanvas = new fabric.StaticCanvas(temp_canvas_id);
        window.fCanvas = fCanvas;
        return fCanvas;
    },
    getTextAttr(item) {
        let result = {};
        let attrList = [
            'fontSize',
            'fontFamily',
            'lineHeight',
            'fontStyle',
            'fontWeight',
            'textAlign',
            'left',
            'top',
            'width','angle',
            'height', 'charSpacing', 'fill'];
        attrList.forEach((attr) => {
            if (item.hasOwnProperty(attr) && item[attr]) {
                result[attr] = item[attr] || '';
            }
        });
        return result;
    },
    addText(canvas, textItem) {
        let cloneData = JSON.parse(JSON.stringify(textItem));
        cloneData.fill = cloneData.color;
        cloneData.charSpacing = cloneData.letterSpacing || '';
        cloneData.fontStyle = cloneData.fontStyle === 'initial' ? '' : cloneData.fontStyle;
        let lh = cloneData.lineHeight ? cloneData.lineHeight / cloneData.fontSize : 'normal';
        cloneData.lineHeight = lh;
        cloneData.angle = cloneData.rotate;
        let textAttr = this.getTextAttr(cloneData);
        let text = new fabric.Textbox(cloneData.name, Object.assign({}, def_text_opts, textAttr));
        canvas.add(text);
    },
    addImg(canvas, imgItem) {
        let cloneData = JSON.parse(JSON.stringify(imgItem));
        return new Promise((resolve, reject) => {
            fabric.Image.fromURL(`${cloneData.url}?v=${new Date().getTime()}`, function (img) {
                img.set({
                    scaleX: imgItem.width / img.width,
                    scaleY: imgItem.height / img.height,
                    angle: cloneData.rotate,
                    left: cloneData.left,
                    top: cloneData.top,
                    width: img.width,
                    height: img.height
                });
                canvas.add(img);
                resolve()
            }, {
                crossOrigin: 'anonymous'
            });
        });
    },
    async toCanvas(bgColor, width, height, dataList) {
        let canvas = this.getCanvas(bgColor, width, height), item;
        let isOpacityTemplate = bgColor === 'rgba(0,0,0,0)';
        dataList = dataList.filter((item) => { // 透明背景时，背景图片要去掉
            if(isOpacityTemplate && (item.isPageBgImg || item.isBgImg)){
                return false;
            }
            return !item.hide;
        });
        for (let index in dataList) {
            item = dataList[index];
            if (item.type === 'text') {
                this.addText(canvas, item);
            } else if (item.type === 'img') {
                await this.addImg(canvas, item);
            }
        }
        this.removeTempDom();
        return canvas.toDataURL();
    },
    removeTempDom(){
        let fCanvasBox;
        ['.canvas-container', '#fabricCanvas'].forEach((selector) => {
            fCanvasBox = document.querySelector(selector);
            if (fCanvasBox) {
                fCanvasBox.remove();
            }
        })
    },
    zip(canvasList, zipName){
        return new Promise((resolve, reject) => {
            if(canvasList.length === 1){
                util.downloadByUrl(canvasList[0].base64, canvasList[0].fileName);
                resolve();
            }else{
                let zip = new JSZip(), imgUrl;
                canvasList.forEach(({base64, fileName}) => {
                    imgUrl = base64.split(';base64,')[1];
                    zip.file(fileName, imgUrl, {base64: true});
                });
                zip.generateAsync({type:"blob"}).then(function(content) {
                    window.saveAs(content, `${zipName}.zip`);
                    resolve();
                });
            }
        });
    }
}